// extracted by mini-css-extract-plugin
module.exports = {"button":"NewVLPCustomCard_button__1EnYR","eventsSelector":"NewVLPCustomCard_eventsSelector__2kaqH","sponsorsLayoutBackground":"NewVLPCustomCard_sponsorsLayoutBackground__1rMHH"};